<template>
  <div class="partner-modal">
    <div class="error-modal-body">
      <div class="row" style="width: 100%; margin: 0; padding: 0">
        <div class="title" style="width: 100%">
          <p>Хүүхдийн мэдээллийг ХУР системээс авах</p>
          <button @click.esc="close">x</button>
        </div>
        <form
          action="POST"
          class="user-edit-panel-profile"
          @submit.prevent="sendData"
        >
          <div class="form-group" style="justify-content: center">
            <input
              type="text"
              v-model="userRegister"
              placeholder="Хэрэглэгчийн регистрийн дугаар"
              disabled
            />
          </div>

          <div class="form-group" style="justify-content: center">
            <input
              type="button"
              @click="sendData"
              class="btn user-btn"
              value="Хүүхдийн мэдээлэл авах"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["userRegister"],
  data() {
    return {
      register: this.userRegister || "",
    };
  },
  methods: {
    close() {
      this.$emit("hideChildrenInfoModal");
    },
    sendData() {
      if (this.register === "") {
        alert("Талбар хоосон байна!");
        return;
      }
      // this.$emit("nextStep");
      this.$cardApi
        .post(
          "/kid-card/hur/tanCode",
          {
            registryNumber: this.register,
            systemId: "BONUS",
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.$emit("nextStep");
          } else {
            this.$emit("hideChildrenInfoModal");
            alert("Хүүхдийн мэдээлэл авахад алдаа гарлаа.");
          }
        });
    },
  },
};
</script>

<style scoped>
.partner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
}
.error-modal-body {
  position: absolute;
  top: 15%;
  width: 600px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  padding-bottom: 30px;
}
.title {
  float: left;
}
.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}
.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}
.box-text {
  padding-left: 40px;
}
.box-text p {
  padding: 10px 0;
  margin: 0;
  border: none;
  color: #7e7e7e;
}
.box-text h2 {
  padding: 10px 0;
  font-size: 16px;
  margin: 0;
  color: #1660ab;
  font-weight: 500;
  border: none;
}
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.btn {
  background-color: #1660ab;
  color: #fff;
  padding: 3px 5px;
  margin-left: 0px;
  line-height: 0.9;
}
.btn.redColor {
  background-color: #ed3237;
}
.top20 {
  margin-top: 20px;
}
.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body div p {
  margin: 0;
}
.error-modal-body .error-img {
  margin-top: 37px !important;
  height: 49px;
  flex: 0.5;
  padding-left: 18px;
  line-height: 1.38;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body img {
  width: 100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.exitBtn {
  top: 0;
  right: 0;
  color: #fff;
  width: 32px;
  height: 32px;
  position: absolute;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 20%;
    width: 80%;
  }
  .box-text {
    padding-left: 30px;
  }
}
.bonus-transfer {
  margin: 0;
  padding: 10px 14px;
  border: 1px dashed #bdbdbd;
  margin-top: 14px;
}
.bonus-transfer p {
  margin: 0;
  font-size: 12px;
}
.colorRed {
  color: #ed3237;
}
.bonus-transfer b {
  color: #1660ab;
}
@media screen and (max-width: 767px) {
  .error-modal-body {
    width: 90%;
    top: 0;
  }
  .col-md-4 {
    max-width: 33.333333%;
  }
  .col-md-8 {
    max-width: 66.666667%;
    padding-left: 10px;
  }
  .box-text h2 {
    font-size: 12px;
  }
  .box-text p {
    font-size: 12px;
  }
  .btn {
    padding: 5px 10px;
    font-size: 14px;
  }
}
</style>
